import { AppBar, Box, Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, ListItem, ListItemAvatar, ListItemText, TextField, Toolbar, Typography, makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';
import { Divider } from "@material-ui/core";
import { parseAddressTypeToIcons } from 'util/parseAddressIcons';
import { Formik, Form, Field, useFormikContext } from 'formik';

import * as Yup from 'yup';
import { ArrowBackIos, Close } from '@material-ui/icons';
import { useTrackEvent } from 'util/trackEvent';

// A custom hook to automatically validate the form on mount
const AutoValidateOnMount = () => {
  const { validateForm } = useFormikContext();
  useEffect(() => {
    validateForm();
  }, [validateForm]);
  return null;
};

const AddressComponentForm = ({
  locationType,
  location,
  onSubmit,
  onCTARef = (b) => { },
}) => {

  const trackEvent = useTrackEvent()

  useEffect(
    () => {
      onCTARef(null)
    }, []
  );
  const validationSchema = Yup.object().shape({
    number: Yup.string().required('Building Number is required'),
    street_name: Yup.string().required('Street Name is required'),
    notes: Yup.string(),
    tower_name: Yup.string(),
    guest_name: Yup.string(),
  });

  useEffect(() => {
    // This can be used for any side effects when location changes
  }, [location]);

  return (
    <Formik
      initialValues={{
        number: '',
        street_name: location?.street || '',
        notes: '',
        tower_name: '',
        guest_name: '',
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        const formData = {
          ...values,
          type_name: 'home',
          name: values.number + ' ' + values.street_name,
          label: values.number + ' ' + values.street_name,
        };
        trackEvent('Create Booking Location Form - Add additional data to location', { values })
        onSubmit(formData);
        setSubmitting(false);
      }}
    >
      {({ values, handleChange, handleBlur, isValid, isSubmitting, touched }) => (
        <Form>
          <AutoValidateOnMount />
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12}>
              <ListItem>
                <ListItemAvatar>
                  {parseAddressTypeToIcons(locationType)}
                </ListItemAvatar>
                <ListItemText
                  primary={location?.display_address_1}
                  secondary={location?.display_address_2}
                />
              </ListItem>
              <Divider />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field as={TextField}
                size="small"
                required
                name="number"
                label="Building Number"
                placeholder='Building Number'
                variant="outlined"
                fullWidth
                value={values.number}
                onChange={handleChange}
                onBlur={handleBlur}
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field as={TextField}
                size="small"
                required
                name="street_name"
                label="Street Name"
                placeholder='Street Name'
                variant="outlined"
                fullWidth
                value={values.street_name}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </Grid>
            {['office', 'hotel', 'condo'].includes(locationType) && (
              <Grid item xs={12} sm={6}>
                <Field as={TextField}
                  size="small"
                  name="tower_name"
                  label="Tower Name"
                  placeholder='Tower Name'
                  variant="outlined"
                  fullWidth
                  value={values.tower_name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </Grid>
            )}
            {locationType === 'hotel' && (
              <Grid item xs={12} sm={6}>
                <Field as={TextField}
                  size="small"
                  name="guest_name"
                  label="Guest Name"
                  placeholder='Guest Name'
                  variant="outlined"
                  fullWidth
                  value={values.guest_name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <Field as={TextField}
                size="small"
                name="notes"
                label="Notes"
                placeholder='Notes'
                variant="outlined"
                fullWidth
                multiline
                minRows={2}
                value={values.notes}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </Grid>
          </Grid>
          <Box mt={2}>
            {<Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={!isValid || isSubmitting || Object.keys(touched).length === 0}
            >
              Use Location
            </Button>}
          </Box>
        </Form>
      )}
    </Formik>
  );
};


const AddressComponentFormDialog = ({
  onCancel = () => { },
  open = false,
  ...props
}) => {
  const trackEvent = useTrackEvent()
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"),
    {
      noSsr: true,
    });

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
      fullScreen={isMobile}
    >
      {isMobile ? (
        
          <Toolbar
            
          >
            <IconButton
              edge="start"
              color="inherit"
              onClick={()=>{
                trackEvent('Create Booking Location Form Additional Data- Cancel')
                onCancel()
              }}
              aria-label="close"
            >
              <ArrowBackIos />
            </IconButton>
            *<Typography variant='h5'
            style={{
              padding: '16px 0px ',
            }}>
              To make sure we get to the right place, please provide us with the following details.
            </Typography>
          </Toolbar>
        
      ) : (
        <DialogTitle>
          <Typography variant='h5'>
            To make sure we get to the right place, please provide us with the following details.
          </Typography>
        </DialogTitle>
      )}
      <DialogContent>
        <AddressComponentForm {...props} />
      </DialogContent>
    </Dialog>

  )
}
export { AddressComponentFormDialog, AddressComponentForm }